import apiClient from "@/services";

const getProducts = async () => {
  try {
    const { status, data } = await apiClient.get("/getProducts");

    if (status === 200) {
      return data;
    } else {
      throw new Error(`Unexpected response status: ${status}`);
    }
  } catch (error) {
    console.error("Error fetching products:", error.message || error);
    return [];
  }
};

export default getProducts;
